export default __webpack_public_path__ + "static/elf_logo-e98bf9a3334d4d992067229bbe5f3ec6.png";